'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_display_Text_Text = require('../../display/Text/Text.cjs.js');
const components_navigation_Link_Link = require('../../navigation/Link/Link.cjs.js');
const SubscriptionForm_module = require('../../../SubscriptionForm.module-CQEDilRD.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const DisclaimerText = ({ color = "primary", termsLink = "https://zapier.com/tos", textType = "Body1", privacyLink = "https://zapier.com/privacy" }) => {
  const textColor = color === "primary" ? "GrayWarm9" : "PrimeWhite";
  return React__default.default.createElement(
    "div",
    { className: SubscriptionForm_module.styles.ctaDisclaimer, "data-zds": true },
    React__default.default.createElement(
      components_display_Text_Text.Text,
      { tag: "p", type: textType, color: textColor },
      "By signing up, you agree to Zapier’s",
      " ",
      React__default.default.createElement(components_navigation_Link_Link.Link, { href: termsLink, color }, "Terms of Service"),
      " ",
      "and",
      " ",
      React__default.default.createElement(components_navigation_Link_Link.Link, { href: privacyLink, color }, "Privacy Policy"),
      "."
    )
  );
};

exports.DisclaimerText = DisclaimerText;
//# sourceMappingURL=DisclaimerText.cjs.js.map
